import { defineSlotRecipe } from '@chakra-ui/react';
import { BorderWidths, Radii, Shadows, Colors, FontSizes, Space } from '../../types';

export const alertSlotRecipe = defineSlotRecipe({
  slots: ['root', 'title', 'description', 'indicator', 'content'],
  base: {
    root: {
      borderWidth: BorderWidths.XS,
      borderRadius: Radii.XL,
      boxShadow: Shadows.XS,
      width: '100%',
      fontSize: FontSizes.MD,
      padding: Space.SM,
      backgroundClip: 'padding-box',
    },
    indicator: {
      margin: 0,
      boxSize: '5',
      display: 'grid',
      placeItems: 'center',
      _icon: { boxSize: '1em' },
    },
    title: {
      color: Colors.TEXT_EMPHASIS,
    },
    description: {
      color: Colors.TEXT_EMPHASIS,
    },
  },
  variants: {
    variant: {
      success: {
        root: { background: Colors.SURFACE_SUCCESS_SUBDUED, borderColor: Colors.SURFACE_SUCCESS_MUTED },
        indicator: { color: Colors.ICON_SUCCESS },
      },
      error: {
        root: { background: Colors.SURFACE_ERROR_SUBDUED, borderColor: Colors.SURFACE_ERROR_MUTED },
        indicator: { color: Colors.ICON_ERROR },
      },
      info: {
        root: { background: Colors.SURFACE_INFO_SUBDUED, borderColor: Colors.SURFACE_INFO_MUTED },
        indicator: { color: Colors.ICON_INFO },
      },
      warning: {
        root: { background: Colors.SURFACE_WARNING_SUBDUED, borderColor: Colors.SURFACE_WARNING_MUTED },
        indicator: { color: Colors.ICON_WARNING },
      },
      neutral: {
        root: { background: Colors.SURFACE_NEUTRAL_SUBDUED, borderColor: Colors.SURFACE_NEUTRAL_MUTED },
        indicator: { color: Colors.ICON_DEFAULT },
      },
    },
    // Chakra's built-in `md` size sets `root.textStyle` ('sm') and `paddingInline`/`paddingBlock` (spacing.4),
    // which override our own `fontSize` and `padding` shorthand, so both are re-declared here.
    size: {
      md: {
        root: {
          textStyle: 'unset',
          fontSize: FontSizes.MD,
          paddingInline: Space.SM,
          paddingBlock: Space.SM,
        },
        indicator: { textStyle: 'unset', fontSize: FontSizes.MD },
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});
